// Internal imports
import { client } from "@/lib/hono";

export interface HeartUser {
  id: string;
  name: string;
  heartedAt: string;
}

export interface RestaurantHearts {
  count: number;
  heartedByMe: boolean;
  users: HeartUser[];
}

const readData = async (response: Response, fallback: string): Promise<RestaurantHearts> => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error((error as { error?: string }).error || fallback);
  }
  const result = (await response.json()) as { success: boolean; data?: RestaurantHearts };
  if (!result.success || !result.data) throw new Error(fallback);
  return result.data;
};

export const heartsService = {
  async getForRestaurant(restaurantId: string): Promise<RestaurantHearts> {
    const response = await client.api.hearts.restaurant[":restaurantId"].$get({ param: { restaurantId } });
    return readData(response, "Failed to load hearts");
  },

  async heart(restaurantId: string): Promise<RestaurantHearts> {
    const response = await client.api.hearts.$post({ json: { restaurantId } });
    return readData(response, "Failed to heart restaurant");
  },

  async unheart(restaurantId: string): Promise<RestaurantHearts> {
    const response = await client.api.hearts[":restaurantId"].$delete({ param: { restaurantId } });
    return readData(response, "Failed to remove heart");
  },
};
